// Translations
import accessKeyManager from 'components/model/access-key-manager/translations/de'
import copyButton from 'components/interface/copy-button/translations/de'
import feedback from 'components/utility/feedback/translations/de'
import loadingError from 'components/utility/loading-error/translations/de'
import pagination from 'components/interface/pagination/translations/de'
import phoneNumberVerifier from 'components/model/phone-number-verifier/translations/de'
import providerButton from 'components/external/provider-button/translations/de'

// Translation: German > Components
const components = Object.freeze({
	external: { providerButton },
	interface: { copyButton, pagination },
	model: { accessKeyManager, phoneNumberVerifier },
	utility: { feedback, loadingError }
})

// Export
export default components
